export const getStyles = (theme) => ({
  container: {
    fontFamily: 'AvenirNext',
    fontSize: '14px',
  },
  backItem: {
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: '14px',
  },
  infoContainer: {},
  label: {
    fontSize: '2em',
    fontFamily: 'AvenirNext-DemiBold',
    verticalAlign: 'middle',
  },
  code: {
    bgcolor: `${theme.palette.primary.main}33`,
    display: 'inline-block',
    padding: '4px 7px',
    margin: '2px 6px',
    borderRadius: '3px',
    color: theme.palette.color.blackMain,
    fontSize: '10px',
    verticalAlign: 'middle',
  },
  assignmentInfo: {
    textAlign: 'left',
  },
  shipmentList: {
    bgcolor: theme.palette.color.grayFourteenth,
  },
  bold: {
    fontFamily: 'AvenirNext-DemiBold',
  },
  timeWindow: {
    display: 'inline-flex',
  },
  timeWindowValue: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: 'inherit',
    color: 'inherit',
  },
  active: {
    color: theme.palette.color.link,
  },
  pending: {
    color: theme.palette.color.orangeTwo,
  },
  in_progress: {
    color: theme.palette.color.lightOrange,
  },
  completed: {
    color: theme.palette.color.green,
  },
  failed: {
    color: theme.palette.color.red,
  },
});
